module.exports = __webpack_public_path__ + "img/checkmark.19f83ad1.svg";